// import { Component, inject, OnInit, OnDestroy } from '@angular/core';
// import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
// import {
//   FormGroup,
//   FormControl,
//   Validators,
//   NonNullableFormBuilder,
//   FormArray,
// } from '@angular/forms';
// import { NzMessageService } from 'ng-zorro-antd/message';
// import { DatePipe } from '@angular/common';
// import { ClientPdfGenService } from '../../../services/pdf-gen-services/client-pdf-gen.service';
// import { Subscription } from 'rxjs';
// import { EventViewModel } from '../../../models-views/event.view.model';
// import { SourcingNeedV2ViewModel } from '../../../models-views/sourcing-needs-v2.view.model';

// // --- Interface for type safety ---
// interface IModalData {
//   eventData: any;
//   complianceData: any[];
//   sourcingData: any;
// }

// @Component({
//   selector: 'app-generate-event-pdf',
//   templateUrl: './generate-event-pdf.component.html',
//   styleUrls: ['./generate-event-pdf.component.scss'],
//   providers: [DatePipe],
//   standalone: false,
// })
// export class GenerateEventPdfComponent implements OnInit, OnDestroy {
//   private readonly fb = inject(NonNullableFormBuilder);
//   private readonly message = inject(NzMessageService);
//   private readonly datePipe = inject(DatePipe);
//   private readonly modalRef = inject(NzModalRef);
//   private readonly modalData: IModalData = inject(NZ_MODAL_DATA);
//   private readonly clientPdfGenService = inject(ClientPdfGenService);
//   private readonly vm = inject(EventViewModel);
//   private readonly sn = inject(SourcingNeedV2ViewModel);

//   stepIndex = 0;
//   highestStepVisited = 0;
//   isLoading = false;
//   private subscriptions: Subscription[] = [];

//   validateForm: FormGroup = this.fb.group({
//     eventName: ['', [Validators.required]],
//     eventStartDate: [null as string | null, [Validators.required]],
//     eventEndDate: [null as string | null, [Validators.required]],
//     includeCoverPage: [false],
//     includeThankYouPage: [false],
//   });
//   displayData: { label: string; value: string; isLink?: boolean }[] = [];

//   otherDetailsForm: FormGroup = this.fb.group({
//     details: this.fb.array<FormGroup>([]),
//   });

//   sourcingNeedsForm: FormGroup = this.fb.group({});
//   sourcingNeedsCategories: {
//     key: string;
//     requiredFlag: string;
//     control: FormGroup;
//   }[] = [];

//   complianceForm: FormGroup = this.fb.group({
//     flexible: [true],
//     items: this.fb.array<FormGroup>([]),
//   });

//   reviewData: any = {};
//   eventId: any = '';
//   sourcing_need: any = '';

//   constructor() {}

//   ngOnInit(): void {
//     const eventData = this.modalData.eventData;
//     if (eventData) {
//       console.log("event data >>>>>>>>>>",eventData)
//       this.eventId = eventData.id;
//       this.sourcing_need = eventData.sourcing_need;
//       this.initializeAllForms(eventData);
//     } else {
//       this.message.error('Could not load event data.');
//     }

//     const safetySub = this.vm.safetyListResponse.subscribe((response) => {
//       if (response?.results) {
//         this.populateComplianceForm(response.results);
//       }
//     });
//     this.subscriptions.push(safetySub);

//     const sourcingSub = this.sn.sourcingNeedModel.subscribe((response) => {
//       if (response) {
//         this.populateSourcingNeedsForm(response);
//       }
//     });
//     this.subscriptions.push(sourcingSub);

//     // --- ADD THIS NEW SUBSCRIPTION ---
//     const flexibleSub = this.complianceForm
//       .get('flexible')
//       ?.valueChanges.subscribe(() => {
//         // When the main switch changes, update validation for every row
//         this.complianceItemsArray.controls.forEach((control) => {
//           this.updateComplianceRowValidation(control as FormGroup);
//         });
//       });
//     if (flexibleSub) {
//       this.subscriptions.push(flexibleSub);
//     }
//   }

//   ngOnDestroy(): void {
//     this.subscriptions.forEach((sub) => sub.unsubscribe());
//   }

//   formatUrl(value: string): string {
//     if (!value) return '';
//     return value.replace(/^(https?:\/\/)/, '');
//   }

//   private formatKeyToLabel(key: string): string {
//     return key
//       .replace(/_/g, ' ')
//       .replace(/\b\w/g, (char) => char.toUpperCase());
//   }

//   initializeAllForms(data: any): void {
//     this.isLoading = true;

//     this.validateForm.patchValue({
//       eventName: data.name,
//       eventStartDate: this.datePipe.transform(
//         data.start_datetime,
//         'EEEE, MMMM d, y'
//       ),
//       eventEndDate: this.datePipe.transform(
//         data.end_datetime,
//         'EEEE, MMMM d, y'
//       ),
//     });

//     const dataForDisplay = {
//       event_type: data.event_type_name,
//       budget: `${data.budget_currency_amount} ${data.budget_currency_type_details?.name}`,
//       client_name: data.client?.name,
//       project_name: data.project_details?.name,
//       country: data.country,
//       state: data.state,
//       event_url: data.event_url,
//       assigned_group: data.assigned_group_name,
//     };
//     this.displayData = Object.keys(dataForDisplay).map((key) => ({
//       label: this.formatKeyToLabel(key),
//       value: dataForDisplay[key],
//       isLink: key === 'event_url',
//     }));

//     const dataForOtherDetails = {
//       event_format: data.event_format_name,
//       city: data.city_name,
//       client_industry_focus: (data.industry_details || [])
//         .map((ind: any) => ind.name)
//         .join(', '),
//       number_of_attendees: data.number_of_attendees,
//       duration: data.duration_name,
//       currency_choice: data.budget_currency_type_details?.name,
//     };
//     const detailsFormArray = this.otherDetailsForm.get('details') as FormArray;
//     detailsFormArray.clear();
//     Object.keys(dataForOtherDetails).forEach((key, index) => {
//       detailsFormArray.push(
//         this.createDetailFormGroup(
//           this.formatKeyToLabel(key),
//           dataForOtherDetails[key] || 'N/A',
//           index + 1
//         )
//       );
//     });

//     this.vm.getSafetyList('', 100, 1, this.eventId);
//     // this.sn.getSouringNeedbyId(this.eventId, 'pdf-generation-component');
//     this.sn.getSouringNeedbyId(this.sourcing_need, 'pdf-generation-component');

//     this.isLoading = false;
//   }

//   private populateSourcingNeedsForm(data: any): void {
//     const joinNames = (arr: any[]) =>
//       (arr || []).map((item) => item.name).join(', ') || 'N/A';

//     const sourcingCategoriesDef = [
//       {
//         key: 'venue',
//         requiredFlag: 'is_venue_required',
//         detailsKey: 'venue_details',
//         label: 'Venue',
//         fields: {
//           venue_name: 'Venue Name',
//           room_type_name: 'Room Type',
//           seating_style_name: 'Seating Style',
//           is_breakout_rooms_required: 'Breakout Rooms Required',
//           number_of_breakout_rooms: 'Number of Breakout Rooms',
//         },
//       },
//       {
//         key: 'catering',
//         requiredFlag: 'is_catering_required',
//         detailsKey: 'catering_details',
//         label: 'Catering',
//         fields: {
//           catering_type_details: 'Catering Type',
//           meal_type_details: 'Meal Type',
//           meal_timing_details: 'Meal Timings',
//           non_alcoholic_beverage_details: 'Non-Alcoholic Beverages',
//           alcoholic_beverage_details: 'Alcoholic Beverages',
//           dietary_preferences_details: 'Dietary Preferences',
//           liquor_license_required: 'Liquor License Required',
//         },
//       },
//       {
//         key: 'production',
//         requiredFlag: 'is_stage_required',
//         detailsKey: null,
//         label: 'Production',
//         fields: {
//           is_stage_required: 'Stage Required',
//           is_registration_desk_required: 'Registration Desk Required',
//         },
//       },
//       {
//         key: 'talent',
//         requiredFlag: 'is_speaker_on_stage_talent',
//         detailsKey: 'speaker_details',
//         label: 'Speaker & Stage Talent',
//         fields: { speaker_details: 'Speakers' },
//       },
//       {
//         key: 'staffing',
//         requiredFlag: 'is_photographer_videographer_required',
//         detailsKey: 'sourcing_need_photo_video_details',
//         label: 'Videographer & Photographer',
//         fields: {
//           photo_description: 'Photo Description',
//           video_description: 'Video Description',
//         },
//       },
//       {
//         key: 'transport',
//         requiredFlag: 'is_transport_required',
//         detailsKey: 'transport_details',
//         label: 'Transport Requirements',
//         fields: {
//           airport_transfers_details: 'Airport Transfers',
//           local_venue_transfers_details: 'Local Venue Transfers',
//           vehicles_type_details: 'Vehicle Types',
//         },
//       },
//       {
//         key: 'gifts',
//         requiredFlag: 'is_gift_required',
//         detailsKey: null,
//         label: 'Gifts',
//         fields: {
//           gift_details: 'Details',
//           gift_rate: 'Rate',
//         },
//       },
//       {
//         key: 'branding',
//         requiredFlag: 'is_branding_collateral_required',
//         detailsKey: 'branding_collateral_details',
//         label: 'Branding & Collateral',
//         fields: {
//           stage_accessories_details: 'Stage & Stage Accessories',
//           guest_management_details: 'Guest Management',
//           guest_management_host_name: 'Guest Management Host',
//           signage_branding_details: 'Signage Branding',
//           demo_engagement_details: 'Demo & Engagement',
//           media_advertising_details: 'Media & Advertising',
//           setup_branding_details: 'Setup Branding',
//         },
//       },
//       {
//         key: 'av',
//         requiredFlag: 'is_av_required',
//         detailsKey: 'av_requirements_details',
//         label: 'AV Requirements',
//         fields: {
//           microphone_details: 'Microphones',
//           speakers_audio_output_details: 'Speakers & Audio Output',
//           audio_equipment_details: 'Audio Equipment',
//           support_infra_details: 'Support Infrastructure',
//           av_staff_details: 'A/V Staff',
//           display_units_details: 'Display Systems',
//           cameras_recording_details: 'Cameras & Recording',
//           video_equipment_details: 'Video Equipment',
//           general_stage_lighting_details: 'Stage Lighting',
//           special_lighting_details: 'Ambient & Decorative Lighting',
//           rigging_support_details: 'Rigging & Support',
//           event_entrance_tunnel_details: 'Event Entrance Tunnel',
//         },
//       },
//       {
//         key: 'furniture',
//         requiredFlag: 'is_furniture_required',
//         detailsKey: null,
//         label: 'Furniture',
//         fields: {
//           furniture_details: 'Details',
//         },
//       },
//       {
//         key: 'experience',
//         requiredFlag: 'is_experience_required',
//         detailsKey: 'experience_type_details',
//         label: 'Experience',
//         fields: { experience_type_details: 'Type' },
//       },
//     ];

//     const formControls = {};
//     sourcingCategoriesDef.forEach((category) => {
//       if (data[category.requiredFlag]) {
//         const detailsSource = category.detailsKey
//           ? data[category.detailsKey]
//           : data;
//         if (detailsSource) {
//           const formArray = this.fb.array<FormGroup>([]);
//           Object.keys(category.fields).forEach((fieldKey) => {
//             // --- UPDATED LOGIC to handle array-based fields correctly ---
//             let value;
//             // If the fieldKey matches the detailsKey, it means we process the whole details object (which is an array)
//             if (
//               fieldKey === category.detailsKey &&
//               Array.isArray(detailsSource)
//             ) {
//               value = detailsSource;
//             } else {
//               // Otherwise, get the property directly from the source
//               value = detailsSource[fieldKey];
//             }

//             if (value !== undefined && value !== null && value !== '') {
//               if (Array.isArray(value)) value = joinNames(value);
//               else if (typeof value === 'boolean') value = value ? 'Yes' : 'No';

//               // Prevent adding a row if the joined array name is 'N/A' (i.e., the array was empty)
//               if (value !== 'N/A') {
//                 formArray.push(
//                   this.createDetailFormGroup(
//                     category.fields[fieldKey],
//                     value,
//                     fieldKey
//                   )
//                 );
//               }
//             }
//           });
//           if (formArray.length > 0) {
//             formControls[category.key] = this.fb.group({
//               label: [category.label],
//               items: formArray,
//             });
//           }
//         }
//       }
//     });
//     this.sourcingNeedsForm = this.fb.group(formControls);

//     // --- MODIFIED: Correctly map categories to include requiredFlag ---
//     this.sourcingNeedsCategories = Object.keys(
//       this.sourcingNeedsForm.controls
//     ).map((key) => {
//       const definition = sourcingCategoriesDef.find((def) => def.key === key);
//       return {
//         key: key,
//         requiredFlag: definition ? definition.requiredFlag : '',
//         control: this.sourcingNeedsForm.controls[key] as FormGroup,
//       };
//     });
//   }

//   private populateComplianceForm(data: any[]): void {
//     const complianceItemsArray = this.complianceForm.get('items') as FormArray;
//     complianceItemsArray.clear();
//     data.forEach((item) => {
//       complianceItemsArray.push(this.createComplianceFormGroup(item));
//     });
//   }

//   private createDetailFormGroup(form: string, value: any, id: any): FormGroup {
//     const group = this.fb.group({
//       // selected: [false],
//       selected: [true],

//       questionText: [form],
//       answerText: [value],
//       originalId: [id],
//     });
//     this.trackSubscription(group.get('selected')?.valueChanges, (selected) => {
//       const control = group.get('answerText');
//       selected
//         ? control?.addValidators(Validators.required)
//         : control?.removeValidators(Validators.required);
//       control?.updateValueAndValidity();
//     });
//     return group;
//   }

//   private createComplianceFormGroup(data: any): FormGroup {
//     const group = this.fb.group({
//       // selected: [false],
//       selected: [true],
//       simpleSelection: [true],
//       name: [data?.compliance_safety_name || '', Validators.required],
//       currency: [data?.currency_details?.name || null, Validators.required],
//       amount: [data?.currency_amount || null],
//       exchangeRate: [data?.exchange_rate || null],
//       amountUsd: [data?.amount_usd || null],
//       originalId: [data?.id || null],
//     });

//     // --- REPLACE the old trackSubscription logic with this ---
//     this.trackSubscription(group.get('selected')?.valueChanges, () => {
//       // When the 'selected' checkbox for this specific row changes, update its validation
//       this.updateComplianceRowValidation(group);
//     });

//     // We also call it once initially to set the correct state
//     this.updateComplianceRowValidation(group);

//     return group;
//   }

//   submitForm(): void {
//     let currentForm: FormGroup;
//     let reviewDataKey: string;
//     switch (this.stepIndex) {
//       case 0:
//         currentForm = this.validateForm;
//         reviewDataKey = 'eventDetails';
//         break;
//       case 1:
//         currentForm = this.otherDetailsForm;
//         reviewDataKey = 'otherDetails';
//         break;
//       case 2:
//         currentForm = this.sourcingNeedsForm;
//         reviewDataKey = 'sourcingNeeds';
//         break;
//       case 3:
//         currentForm = this.complianceForm;
//         reviewDataKey = 'compliance';
//         break;
//       default:
//         return;
//     }
//     if (this.isStepValid(this.stepIndex, currentForm)) {
//       this.goToNextStep(currentForm, reviewDataKey);
//     } else {
//       this.handleInvalidForm(currentForm);
//     }
//   }

//   isStepValid(stepIndex: number, form: FormGroup): boolean {
//     if (!form.valid) return false;

//     const checkCustomRows = (formArray: FormArray) => {
//       if (!formArray || !formArray.controls) return true;
//       for (const control of formArray.controls) {
//         if (control.get('originalId')?.value === null) {
//           const textControl =
//             control.get('questionText') || control.get('name');
//           const valueControl = control.get('answerText');
//           if (!textControl?.value || (valueControl && !valueControl.value)) {
//             return false;
//           }
//         }
//       }
//       return true;
//     };

//     if (stepIndex === 1) return checkCustomRows(this.detailsFormArray);
//     if (stepIndex === 2) {
//       for (const key in form.controls) {
//         const categoryGroup = form.get(key) as FormGroup;
//         const itemsArray = categoryGroup.get('items') as FormArray;
//         if (!checkCustomRows(itemsArray)) return false;
//       }
//     }
//     if (stepIndex === 3) return checkCustomRows(this.complianceItemsArray);
//     return true;
//   }

//   goToNextStep(form: FormGroup, reviewDataKey: string): void {
//     this.reviewData[reviewDataKey] = form.value;
//     this.stepIndex++;
//     this.highestStepVisited = Math.max(this.highestStepVisited, this.stepIndex);
//   }

//   goToPreviousStep(): void {
//     if (this.stepIndex > 0) {
//       this.stepIndex--;
//     }
//   }

//   handleInvalidForm(form: FormGroup): void {
//     this.markFormGroupTouched(form);
//     this.message.error(
//       'Please complete all required fields, including any new custom rows, before proceeding.'
//     );
//   }

//   onIndexChange(index: number): void {
//     if (index <= this.highestStepVisited) {
//       this.stepIndex = index;
//     }
//   }

//   onDownloadPdf(): void {
//     this.isLoading = true;
//     this.message.info('Generating PDF...');

//     this.clientPdfGenService
//       .generateEventPdf(this.reviewData)
//       .then(() => {
//         this.message.success('PDF downloaded successfully!');
//         this.modalRef.destroy();
//       })
//       .catch((error) => {
//         this.message.error('An error occurred while generating the PDF.');
//         console.error('PDF Generation Error from service:', error);
//       })
//       .finally(() => {
//         this.isLoading = false;
//       });
//   }

//   get detailsFormArray(): FormArray {
//     return this.otherDetailsForm.get('details') as FormArray;
//   }
//   get complianceItemsArray(): FormArray {
//     return this.complianceForm.get('items') as FormArray;
//   }
//   getSourcingNeedsFormArray(key: string): FormArray {
//     return (this.sourcingNeedsForm.get(key) as FormGroup)?.get(
//       'items'
//     ) as FormArray;
//   }

//   get filteredOtherDetails(): any[] {
//     return (
//       this.reviewData.otherDetails?.details?.filter((d: any) => d.selected) ||
//       []
//     );
//   }
//   get filteredComplianceItems(): any[] {
//     return (
//       this.reviewData.compliance?.items?.filter((i: any) => i.selected) || []
//     );
//   }
//   getFilteredSourcingNeeds(): any[] {
//     if (!this.reviewData.sourcingNeeds) return [];
//     let allSelectedItems = [];
//     Object.keys(this.reviewData.sourcingNeeds).forEach((key) => {
//       const category = this.reviewData.sourcingNeeds[key];
//       const selectedInCategory = category.items.filter((item) => item.selected);
//       if (selectedInCategory.length > 0) {
//         allSelectedItems.push({
//           label: category.label,
//           items: selectedInCategory,
//         });
//       }
//     });
//     return allSelectedItems;
//   }

//   private trackSubscription(
//     observable: any,
//     callback: (value: any) => void
//   ): void {
//     const sub = observable?.subscribe(callback);
//     if (sub) this.subscriptions.push(sub);
//   }

//   addCustomRow(formArray: FormArray, type: 'detail' | 'compliance'): void {
//     let newRow: FormGroup;

//     if (type === 'detail') {
//       newRow = this.createDetailFormGroup('', '', null);
//     } else {
//       newRow = this.createComplianceFormGroup({});
//     }

//     newRow.get('selected')?.setValue(true);
//     formArray.push(newRow);

//     this.message.info('New custom field added.');
//   }

//   removeCustomRow(formArray: FormArray, index: number): void {
//     const control = formArray.at(index);
//     if (control?.get('originalId')?.value === null) {
//       formArray.removeAt(index);
//       this.message.warning('Custom field removed.');
//     } else {
//       this.message.error('Only custom-added rows can be removed.');
//     }
//   }

//   private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
//     Object.values(formGroup.controls).forEach((control) => {
//       if (control instanceof FormControl) {
//         control.markAsDirty();
//         control.updateValueAndValidity({ onlySelf: true });
//       } else if (control instanceof FormGroup || control instanceof FormArray) {
//         this.markFormGroupTouched(control);
//       }
//     });
//   }

//   trackByIndex(index: number, item: any): number {
//     return index;
//   }
//   closeModal(): void {
//     this.modalRef.destroy();
//   }

//   private updateComplianceRowValidation(rowGroup: FormGroup): void {
//     const isSelected = rowGroup.get('selected')?.value;
//     const isFlexible = this.complianceForm.get('flexible')?.value;

//     const nameCtrl = rowGroup.get('name');
//     const currencyCtrl = rowGroup.get('currency');
//     const amountCtrl = rowGroup.get('amount');

//     if (!nameCtrl || !currencyCtrl || !amountCtrl) {
//       return; // Safety check
//     }

//     // Clear any existing validators before applying new ones
//     nameCtrl.clearValidators();
//     currencyCtrl.clearValidators();
//     amountCtrl.clearValidators();

//     if (isSelected) {
//       // If the row is selected to be included in the PDF
//       nameCtrl.setValidators([Validators.required]);

//       if (isFlexible) {
//         // When flexible editing is ON, Currency and Amount are also required
//         currencyCtrl.setValidators([Validators.required]);
//         amountCtrl.setValidators([Validators.required]);
//       }
//     }

//     // Update the controls to apply the new validation rules
//     nameCtrl.updateValueAndValidity();
//     currencyCtrl.updateValueAndValidity();
//     amountCtrl.updateValueAndValidity();
//   }

//   getEmoji(key: string): string {
//     const emojiMap: { [key: string]: string } = {
//       is_venue_required: '🏛️',
//       is_experience_required: '🎉',
//       is_furniture_required: '🪑',
//       is_speaker_on_stage_talent: '🎤',
//       is_transport_required: '🚖',
//       is_gift_required: '🎁',
//       is_catering_required: '🍽️',
//       is_branding_collateral_required: '🏷️',
//       is_av_required: '🎧',
//       is_photographer_videographer_required: '🎥',
//     };
//     return emojiMap[key] || '❓';
//   }
// }


import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import {
  FormGroup,
  FormControl,
  Validators,
  NonNullableFormBuilder,
  FormArray,
} from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DatePipe } from '@angular/common';
import { ClientPdfGenService } from '../../../services/pdf-gen-services/client-pdf-gen.service';
import { Subscription } from 'rxjs';
import { EventViewModel } from '../../../models-views/event.view.model';
import { SourcingNeedV2ViewModel } from '../../../models-views/sourcing-needs-v2.view.model';

// --- Interface for type safety ---
interface IModalData {
  eventData: any;
  complianceData: any[];
  sourcingData: any;
}

@Component({
  selector: 'app-generate-event-pdf',
  templateUrl: './generate-event-pdf.component.html',
  styleUrls: ['./generate-event-pdf.component.scss'],
  providers: [DatePipe],
  standalone: false,
})
export class GenerateEventPdfComponent implements OnInit, OnDestroy {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly message = inject(NzMessageService);
  private readonly datePipe = inject(DatePipe);
  private readonly modalRef = inject(NzModalRef);
  private readonly modalData: IModalData = inject(NZ_MODAL_DATA);
  private readonly clientPdfGenService = inject(ClientPdfGenService);
  private readonly vm = inject(EventViewModel);
  private readonly sn = inject(SourcingNeedV2ViewModel);

  stepIndex = 0;
  highestStepVisited = 0;
  isLoading = false;
  private subscriptions: Subscription[] = [];

  // --- NEW: Flag to control compliance step visibility ---
  showComplianceStep = true;

  validateForm: FormGroup = this.fb.group({
    eventName: ['', [Validators.required]],
    eventStartDate: [null as string | null, [Validators.required]],
    eventEndDate: [null as string | null, [Validators.required]],
    includeCoverPage: [false],
    includeThankYouPage: [false],
  });
  displayData: { label: string; value: string; isLink?: boolean }[] = [];

  otherDetailsForm: FormGroup = this.fb.group({
    details: this.fb.array<FormGroup>([]),
  });

  sourcingNeedsForm: FormGroup = this.fb.group({});
  sourcingNeedsCategories: {
    key: string;
    requiredFlag: string;
    control: FormGroup;
  }[] = [];

  complianceForm: FormGroup = this.fb.group({
    flexible: [true],
    items: this.fb.array<FormGroup>([]),
  });

  reviewData: any = {};
  eventId: any = '';
  sourcing_need: any = '';

  constructor() {}

  ngOnInit(): void {
    const eventData = this.modalData.eventData;
    if (eventData) {
      // --- MODIFIED: Check the flag from input data ---
      this.showComplianceStep = eventData.is_compliance_safety_required;

      this.eventId = eventData.id;
      this.sourcing_need = eventData.sourcing_need;
      this.initializeAllForms(eventData);
    } else {
      this.message.error('Could not load event data.');
    }

    // --- MODIFIED: Only subscribe if the step is visible ---
    if (this.showComplianceStep) {
      const safetySub = this.vm.safetyListResponse.subscribe((response) => {
        if (response?.results) {
          this.populateComplianceForm(response.results);
        }
      });
      this.subscriptions.push(safetySub);

      const flexibleSub = this.complianceForm
        .get('flexible')
        ?.valueChanges.subscribe(() => {
          this.complianceItemsArray.controls.forEach((control) => {
            this.updateComplianceRowValidation(control as FormGroup);
          });
        });
      if (flexibleSub) {
        this.subscriptions.push(flexibleSub);
      }
    }

    const sourcingSub = this.sn.sourcingNeedModel.subscribe((response) => {
      if (response) {
        this.populateSourcingNeedsForm(response);
      }
    });
    this.subscriptions.push(sourcingSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  formatUrl(value: string): string {
    if (!value) return '';
    return value.replace(/^(https?:\/\/)/, '');
  }

  private formatKeyToLabel(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  initializeAllForms(data: any): void {
    this.isLoading = true;

    this.validateForm.patchValue({
      eventName: data.name,
      eventStartDate: this.datePipe.transform(
        data.start_datetime,
        'EEEE, MMMM d, y'
      ),
      eventEndDate: this.datePipe.transform(
        data.end_datetime,
        'EEEE, MMMM d, y'
      ),
    });

    const dataForDisplay = {
      event_type: data.event_type_name,
      budget: `${data.budget_currency_amount} ${data.budget_currency_type_details?.name}`,
      client_name: data.client?.name,
      project_name: data.project_details?.name,
      country: data.country,
      state: data.state,
      event_url: data.event_url,
      assigned_group: data.assigned_group_name,
    };
    this.displayData = Object.keys(dataForDisplay).map((key) => ({
      label: this.formatKeyToLabel(key),
      value: dataForDisplay[key],
      isLink: key === 'event_url',
    }));

    const dataForOtherDetails = {
      event_format: data.event_format_name,
      city: data.city_name,
      client_industry_focus: (data.industry_details || [])
        .map((ind: any) => ind.name)
        .join(', '),
      number_of_attendees: data.number_of_attendees,
      duration: data.duration_name,
      currency_choice: data.budget_currency_type_details?.name,
    };
    const detailsFormArray = this.otherDetailsForm.get('details') as FormArray;
    detailsFormArray.clear();
    Object.keys(dataForOtherDetails).forEach((key, index) => {
      detailsFormArray.push(
        this.createDetailFormGroup(
          this.formatKeyToLabel(key),
          dataForOtherDetails[key] || 'N/A',
          index + 1
        )
      );
    });

    // --- MODIFIED: Only call API if the step will be shown ---
    if (this.showComplianceStep) {
      this.vm.getSafetyList('', 100, 1, this.eventId);
    }
    this.sn.getSouringNeedbyId(this.sourcing_need, 'pdf-generation-component');

    this.isLoading = false;
  }

  private populateSourcingNeedsForm(data: any): void {
    const joinNames = (arr: any[]) =>
      (arr || []).map((item) => item.name).join(', ') || 'N/A';

    const sourcingCategoriesDef = [
        {
            key: 'venue',
            requiredFlag: 'is_venue_required',
            detailsKey: 'venue_details',
            label: 'Venue',
            fields: {
                venue_name: 'Venue Name',
                room_type_name: 'Room Type',
                seating_style_name: 'Seating Style',
                is_breakout_rooms_required: 'Breakout Rooms Required',
                number_of_breakout_rooms: 'Number of Breakout Rooms',
            },
        },
        {
            key: 'catering',
            requiredFlag: 'is_catering_required',
            detailsKey: 'catering_details',
            label: 'Catering',
            fields: {
                catering_type_details: 'Catering Type',
                meal_type_details: 'Meal Type',
                meal_timing_details: 'Meal Timings',
                non_alcoholic_beverage_details: 'Non-Alcoholic Beverages',
                alcoholic_beverage_details: 'Alcoholic Beverages',
                dietary_preferences_details: 'Dietary Preferences',
                liquor_license_required: 'Liquor License Required',
            },
        },
        {
            key: 'production',
            requiredFlag: 'is_stage_required',
            detailsKey: null,
            label: 'Production',
            fields: {
                is_stage_required: 'Stage Required',
                is_registration_desk_required: 'Registration Desk Required',
            },
        },
        {
            key: 'talent',
            requiredFlag: 'is_speaker_on_stage_talent',
            detailsKey: 'speaker_details',
            label: 'Talent',
            fields: { speaker_details: 'Speakers' },
        },
        {
            key: 'staffing',
            requiredFlag: 'is_photographer_videographer_required',
            detailsKey: 'sourcing_need_photo_video_details',
            label: 'Videographer & Photographer',
            fields: {
                photo_description: 'Photo Description',
                video_description: 'Video Description',
            },
        },
        {
            key: 'transport',
            requiredFlag: 'is_transport_required',
            detailsKey: 'transport_details',
            label: 'Transport Requirements',
            fields: {
                airport_transfers_details: 'Airport Transfers',
                local_venue_transfers_details: 'Local Venue Transfers',
                vehicles_type_details: 'Vehicle Types',
            },
        },
        {
            key: 'gifts',
            requiredFlag: 'is_gift_required',
            detailsKey: null,
            label: 'Gifts',
            fields: {
                gift_details: 'Details',
                gift_rate: 'Rate',
            },
        },
        {
            key: 'branding',
            requiredFlag: 'is_branding_collateral_required',
            detailsKey: 'branding_collateral_details',
            label: 'Branding & Collateral',
            fields: {
                stage_accessories_details: 'Stage & Stage Accessories',
                guest_management_details: 'Guest Management',
                guest_management_host_name: 'Guest Management Host',
                signage_branding_details: 'Signage Branding',
                demo_engagement_details: 'Demo & Engagement',
                media_advertising_details: 'Media & Advertising',
                setup_branding_details: 'Setup Branding',
            },
        },
        {
            key: 'av',
            requiredFlag: 'is_av_required',
            detailsKey: 'av_requirements_details',
            label: 'AV Requirements',
            fields: {
                microphone_details: 'Microphones',
                speakers_audio_output_details: 'Speakers & Audio Output',
                audio_equipment_details: 'Audio Equipment',
                support_infra_details: 'Support Infrastructure',
                av_staff_details: 'A/V Staff',
                display_units_details: 'Display Systems',
                cameras_recording_details: 'Cameras & Recording',
                video_equipment_details: 'Video Equipment',
                general_stage_lighting_details: 'Stage Lighting',
                special_lighting_details: 'Ambient & Decorative Lighting',
                lighting_control_details: 'Lighting Control',
                rigging_support_details: 'Rigging & Support',
                event_entrance_tunnel_details: 'Event Entrance Tunnel',
            },
        },
        {
            key: 'furniture',
            requiredFlag: 'is_furniture_required',
            detailsKey: null,
            label: 'Furniture',
            fields: {
                furniture_details: 'Details',
            },
        },
        {
            key: 'experience',
            requiredFlag: 'is_experience_required',
            detailsKey: 'experience_type_details',
            label: 'Experience',
            fields: { experience_type_details: 'Type' },
        },
        {
          key: 'productionFabrication',
          requiredFlag: 'is_production_fabrication_required',
          detailsKey: 'production_and_fabrication_details',
          label: 'Production & Fabrication',
          fields: {
            event_structures_details: 'Event Structures',
            infrastructure_details: 'Infrastructure',
            live_streaming_hybrid_details: 'Live Streaming & Hybrid',
            intercom_communication_details: 'Intercom & Communication',
          },
        },
    ];

    const formControls = {};
    sourcingCategoriesDef.forEach((category) => {
      if (data[category.requiredFlag]) {
        const detailsSource = category.detailsKey
          ? data[category.detailsKey]
          : data;
        if (detailsSource) {
          const formArray = this.fb.array<FormGroup>([]);
          Object.keys(category.fields).forEach((fieldKey) => {
            let value;
            if (
              fieldKey === category.detailsKey &&
              Array.isArray(detailsSource)
            ) {
              value = detailsSource;
            } else {
              value = detailsSource[fieldKey];
            }

            if (value !== undefined && value !== null && value !== '') {
              if (Array.isArray(value)) value = joinNames(value);
              else if (typeof value === 'boolean') value = value ? 'Yes' : 'No';

              if (value !== 'N/A') {
                formArray.push(
                  this.createDetailFormGroup(
                    category.fields[fieldKey],
                    value,
                    fieldKey
                  )
                );
              }
            }
          });
          if (formArray.length > 0) {
            formControls[category.key] = this.fb.group({
              label: [category.label],
              items: formArray,
            });
          }
        }
      }
    });
    this.sourcingNeedsForm = this.fb.group(formControls);

    this.sourcingNeedsCategories = Object.keys(
      this.sourcingNeedsForm.controls
    ).map((key) => {
      const definition = sourcingCategoriesDef.find((def) => def.key === key);
      return {
        key: key,
        requiredFlag: definition ? definition.requiredFlag : '',
        control: this.sourcingNeedsForm.controls[key] as FormGroup,
      };
    });
  }

  private populateComplianceForm(data: any[]): void {
    const complianceItemsArray = this.complianceForm.get('items') as FormArray;
    complianceItemsArray.clear();
    data.forEach((item) => {
      complianceItemsArray.push(this.createComplianceFormGroup(item));
    });
  }

  private createDetailFormGroup(form: string, value: any, id: any): FormGroup {
    const group = this.fb.group({
      selected: [true],
      questionText: [form],
      answerText: [value],
      originalId: [id],
    });
    this.trackSubscription(group.get('selected')?.valueChanges, (selected) => {
      const control = group.get('answerText');
      selected
        ? control?.addValidators(Validators.required)
        : control?.removeValidators(Validators.required);
      control?.updateValueAndValidity();
    });
    return group;
  }

  private createComplianceFormGroup(data: any): FormGroup {
    const group = this.fb.group({
      selected: [true],
      simpleSelection: [true],
      name: [data?.compliance_safety_name || '', Validators.required],
      currency: [data?.currency_details?.name || null, Validators.required],
      amount: [data?.currency_amount || null],
      exchangeRate: [data?.exchange_rate || null],
      amountUsd: [data?.amount_usd || null],
      originalId: [data?.id || null],
    });

    this.trackSubscription(group.get('selected')?.valueChanges, () => {
      this.updateComplianceRowValidation(group);
    });

    this.updateComplianceRowValidation(group);

    return group;
  }

  submitForm(): void {
    let currentForm: FormGroup;
    let reviewDataKey: string;

    switch (this.stepIndex) {
      case 0:
        currentForm = this.validateForm;
        reviewDataKey = 'eventDetails';
        break;
      case 1:
        currentForm = this.otherDetailsForm;
        reviewDataKey = 'otherDetails';
        break;
      case 2:
        currentForm = this.sourcingNeedsForm;
        reviewDataKey = 'sourcingNeeds';
        break;
      case 3:
        // --- CORRECTED LOGIC ---
        // If the compliance step is hidden, this state should not be reachable
        // via a "Next" button. We return safely to prevent fallthrough.
        if (!this.showComplianceStep) {
          return;
        }
        currentForm = this.complianceForm;
        reviewDataKey = 'compliance';
        break;
      default:
        return;
    }

    if (this.isStepValid(this.stepIndex, currentForm)) {
      this.goToNextStep(currentForm, reviewDataKey);
    } else {
      this.handleInvalidForm(currentForm);
    }
  }

  isStepValid(stepIndex: number, form: FormGroup): boolean {
    if (!form.valid) return false;

    const checkCustomRows = (formArray: FormArray) => {
      if (!formArray || !formArray.controls) return true;
      for (const control of formArray.controls) {
        if (control.get('originalId')?.value === null) {
          const textControl =
            control.get('questionText') || control.get('name');
          const valueControl = control.get('answerText');
          if (!textControl?.value || (valueControl && !valueControl.value)) {
            return false;
          }
        }
      }
      return true;
    };

    if (stepIndex === 1) return checkCustomRows(this.detailsFormArray);
    if (stepIndex === 2) {
      for (const key in form.controls) {
        const categoryGroup = form.get(key) as FormGroup;
        const itemsArray = categoryGroup.get('items') as FormArray;
        if (!checkCustomRows(itemsArray)) return false;
      }
    }
    if (stepIndex === 3 && this.showComplianceStep) {
      return checkCustomRows(this.complianceItemsArray);
    }
    return true;
  }

  goToNextStep(form: FormGroup, reviewDataKey: string): void {
    this.reviewData[reviewDataKey] = form.value;
    this.stepIndex++;
    this.highestStepVisited = Math.max(this.highestStepVisited, this.stepIndex);
  }

  goToPreviousStep(): void {
    if (this.stepIndex > 0) {
      this.stepIndex--;
    }
  }

  handleInvalidForm(form: FormGroup): void {
    this.markFormGroupTouched(form);
    this.message.error(
      'Please complete all required fields, including any new custom rows, before proceeding.'
    );
  }

  onIndexChange(index: number): void {
    if (index <= this.highestStepVisited) {
      this.stepIndex = index;
    }
  }

  onDownloadPdf(): void {
    this.isLoading = true;
    this.message.info('Generating PDF...');

    this.clientPdfGenService
      .generateEventPdf(this.reviewData)
      .then(() => {
        this.message.success('PDF downloaded successfully!');
        this.modalRef.destroy();
      })
      .catch((error) => {
        this.message.error('An error occurred while generating the PDF.');
        console.error('PDF Generation Error from service:', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  get detailsFormArray(): FormArray {
    return this.otherDetailsForm.get('details') as FormArray;
  }
  get complianceItemsArray(): FormArray {
    return this.complianceForm.get('items') as FormArray;
  }
  getSourcingNeedsFormArray(key: string): FormArray {
    return (this.sourcingNeedsForm.get(key) as FormGroup)?.get(
      'items'
    ) as FormArray;
  }

  getFilteredSourcingNeeds(): any[] {
    if (!this.reviewData.sourcingNeeds) return [];
    let allSelectedItems = [];
    Object.keys(this.reviewData.sourcingNeeds).forEach((key) => {
      const category = this.reviewData.sourcingNeeds[key];
      const selectedInCategory = category.items.filter((item) => item.selected);
      if (selectedInCategory.length > 0) {
        allSelectedItems.push({
          label: category.label,
          items: selectedInCategory,
        });
      }
    });
    return allSelectedItems;
  }

  private trackSubscription(
    observable: any,
    callback: (value: any) => void
  ): void {
    const sub = observable?.subscribe(callback);
    if (sub) this.subscriptions.push(sub);
  }

  addCustomRow(formArray: FormArray, type: 'detail' | 'compliance'): void {
    let newRow: FormGroup;

    if (type === 'detail') {
      newRow = this.createDetailFormGroup('', '', null);
    } else {
      newRow = this.createComplianceFormGroup({});
    }

    newRow.get('selected')?.setValue(true);
    formArray.push(newRow);

    this.message.info('New custom field added.');
  }

  removeCustomRow(formArray: FormArray, index: number): void {
    const control = formArray.at(index);
    if (control?.get('originalId')?.value === null) {
      formArray.removeAt(index);
      this.message.warning('Custom field removed.');
    } else {
      this.message.error('Only custom-added rows can be removed.');
    }
  }

  private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormControl) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      }
    });
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
  closeModal(): void {
    this.modalRef.destroy();
  }

  private updateComplianceRowValidation(rowGroup: FormGroup): void {
    const isSelected = rowGroup.get('selected')?.value;
    const isFlexible = this.complianceForm.get('flexible')?.value;

    const nameCtrl = rowGroup.get('name');
    const currencyCtrl = rowGroup.get('currency');
    const amountCtrl = rowGroup.get('amount');

    if (!nameCtrl || !currencyCtrl || !amountCtrl) {
      return; // Safety check
    }

    nameCtrl.clearValidators();
    currencyCtrl.clearValidators();
    amountCtrl.clearValidators();

    if (isSelected) {
      nameCtrl.setValidators([Validators.required]);

      if (isFlexible) {
        currencyCtrl.setValidators([Validators.required]);
        amountCtrl.setValidators([Validators.required]);
      }
    }

    nameCtrl.updateValueAndValidity();
    currencyCtrl.updateValueAndValidity();
    amountCtrl.updateValueAndValidity();
  }

  getEmoji(key: string): string {
    const emojiMap: { [key: string]: string } = {
      is_venue_required: '🏛️',
      is_experience_required: '🎉',
      is_furniture_required: '🪑',
      is_speaker_on_stage_talent: '🎤',
      is_transport_required: '🚖',
      is_gift_required: '🎁',
      is_catering_required: '🍽️',
      is_branding_collateral_required: '🏷️',
      is_av_required: '🎧',
      is_photographer_videographer_required: '🎥',
      is_production_fabrication_required: '🏗️',
    };
    return emojiMap[key] || '❓';
  }
}
